import { ROLE_ADMIN, ROLE_COMPANY, ROLE_RESTAURANT } from '@/enum/roles'
import { COMPANY_TYPE_PREPAID } from '@/enum/companyType'

// A prepaid company is managed in the company-admin portal; its company admins are
// sent there instead of using this admin (tasks#204). Frontend-only gate: the API stays
// open because the portal uses it too.

// The impersonation plugin stores the super admin's refresh token and the impersonated
// user id; the marker only counts for the user it was written for.
export function isImpersonatingUser(userId) {
    const marker = window.localStorage.getItem('impersonate')
    const impersonatedUser = window.localStorage.getItem('impersonateUser')

    return (
        !!marker &&
        impersonatedUser !== null &&
        String(impersonatedUser) === String(userId)
    )
}

export function isBlockedForCompanyPortal({ roles, userId, company }) {
    if (!company || !roles) return false
    if (roles.indexOf(ROLE_COMPANY) === -1) return false
    if (roles.indexOf(ROLE_ADMIN) !== -1) return false
    if (roles.indexOf(ROLE_RESTAURANT) !== -1) return false
    if (company.type !== COMPANY_TYPE_PREPAID) return false

    return !isImpersonatingUser(userId)
}

export default {
    isImpersonatingUser,
    isBlockedForCompanyPortal,
}
